import Chart from 'chart.js/auto';

// Match chart text to the app's Containers for Change typography.
Chart.defaults.font.family = "'Poppins', system-ui, sans-serif";
Chart.defaults.color = '#626866';

export default Chart;
